export enum ModalPositionEnum {
    fixed = "fixed",
    absolute = "absolute",
}

export enum ModalHeightEnum {
    auto = "content",
    wallet = "wallet",
}

export enum ModalWidthEnum {
    page = "page",
    custom = "custom",
}

export enum ModalBackgroundEnum {
    body = "body",
    walletVerify = "walletVerify",
    preload = "preload",
    casino = "casino",
    login = "login",
    dropdown = "dropdown",
    none = "none",
}

export enum ModalShadowEnum {
    none = "none",
}

export enum ModalBorderRadiusEnum {
    default = "default",
    onlyTop = "onlyTop",
    large = "large",
    base = "base",
}

export enum ModalDirectionEnum {
    column = "column",
}

export enum ModalOverflowEnum {
    hidden = "hidden",
    visible = "visible",
}

export interface IModalStyleConfig {
    position: ModalPositionEnum;
    height: ModalHeightEnum;
    width: ModalWidthEnum;
    background: ModalBackgroundEnum;
    borderRadius: ModalBorderRadiusEnum;
    boxShadow: ModalShadowEnum;
    overflow: ModalOverflowEnum;
    direction: ModalDirectionEnum;
}

export const CONFIRM_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    height: ModalHeightEnum.auto,
    borderRadius: ModalBorderRadiusEnum.default,
    direction: ModalDirectionEnum.column,
    overflow: ModalOverflowEnum.hidden,
};

export const VERIFY_WALLET_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    height: ModalHeightEnum.auto,
    background: ModalBackgroundEnum.walletVerify,
    borderRadius: ModalBorderRadiusEnum.default,
};

export const VERIFY_KYC_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    height: ModalHeightEnum.auto,
    width: ModalWidthEnum.page,
    borderRadius: ModalBorderRadiusEnum.onlyTop,
};

export const VERIFY_DETAILS_CONFIG: Partial<IModalStyleConfig> = {
    height: ModalHeightEnum.auto,
    position: ModalPositionEnum.fixed,
};

export const VERIFICATION_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    height: ModalHeightEnum.auto,
    overflow: ModalOverflowEnum.hidden,
    borderRadius: ModalBorderRadiusEnum.default,
};

export const DETAILS_COMPACT_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    height: ModalHeightEnum.auto,
    width: ModalWidthEnum.page,
    direction: ModalDirectionEnum.column,
    overflow: ModalOverflowEnum.hidden,
    borderRadius: ModalBorderRadiusEnum.onlyTop,
};

export const PERSONAL_DETAILS_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    width: ModalWidthEnum.page,
    direction: ModalDirectionEnum.column,
    overflow: ModalOverflowEnum.hidden,
    borderRadius: ModalBorderRadiusEnum.onlyTop,
    background: ModalBackgroundEnum.body,
};

export const WALLET_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    background: ModalBackgroundEnum.walletVerify,
    overflow: ModalOverflowEnum.visible,
};

export const WALLET_PIX_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    height: ModalHeightEnum.wallet,
    width: ModalWidthEnum.custom,
    overflow: ModalOverflowEnum.visible,
    borderRadius: ModalBorderRadiusEnum.default,
};

export const WALLET_MULTI_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    ...WALLET_PIX_MODAL_CONFIG,
};

export const WALLET_MULTI_PRO_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    ...WALLET_MULTI_MODAL_CONFIG,
};

export const WALLET_TOLA_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    height: ModalHeightEnum.auto,
    width: ModalWidthEnum.custom,
    borderRadius: ModalBorderRadiusEnum.default,
};

export const LOGIN_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    height: ModalHeightEnum.auto,
    width: ModalWidthEnum.page,
    borderRadius: ModalBorderRadiusEnum.onlyTop,
    background: ModalBackgroundEnum.login,
};

export const SIGNUP_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    height: ModalHeightEnum.auto,
    width: ModalWidthEnum.page,
    borderRadius: ModalBorderRadiusEnum.onlyTop,
    background: ModalBackgroundEnum.login,
};

export const INACTIVITY_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    height: ModalHeightEnum.auto,
    borderRadius: ModalBorderRadiusEnum.default,
};

export const BETSLIP_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    width: ModalWidthEnum.page,
    borderRadius: ModalBorderRadiusEnum.onlyTop,
    direction: ModalDirectionEnum.column,
};

export const NOTIFICATION_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    height: ModalHeightEnum.auto,
    borderRadius: ModalBorderRadiusEnum.large,
    boxShadow: ModalShadowEnum.none,
    background: ModalBackgroundEnum.none,
    direction: ModalDirectionEnum.column,
};

export const REELS_CONFIG: Partial<IModalStyleConfig> = {
    width: ModalWidthEnum.custom,
    background: ModalBackgroundEnum.preload,
    borderRadius: ModalBorderRadiusEnum.large,
};

export const CASINO_TOOLS_CONFIG: Partial<IModalStyleConfig> = {
    direction: ModalDirectionEnum.column,
    width: ModalWidthEnum.page,
    height: ModalHeightEnum.auto,
    borderRadius: ModalBorderRadiusEnum.onlyTop,
    background: ModalBackgroundEnum.casino,
};

export const CASINO_FAVORITES_CONFIG: Partial<IModalStyleConfig> = {
    overflow: ModalOverflowEnum.hidden,
    direction: ModalDirectionEnum.column,
    borderRadius: ModalBorderRadiusEnum.onlyTop,
    width: ModalWidthEnum.page,
};

export const CASINO_FAVORITES_ITEM_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    height: ModalHeightEnum.auto,
    width: ModalWidthEnum.custom,
    background: ModalBackgroundEnum.none,
    boxShadow: ModalShadowEnum.none,
    overflow: ModalOverflowEnum.hidden,
};

export const GAME_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    width: ModalWidthEnum.page,
    borderRadius: ModalBorderRadiusEnum.onlyTop,
    background: ModalBackgroundEnum.body,
    direction: ModalDirectionEnum.column,
};

export const CUSTOM_DROPDOWN_MODAL_CONFIG: Partial<IModalStyleConfig> = {
    height: ModalHeightEnum.auto,
    background: ModalBackgroundEnum.dropdown,
    borderRadius: ModalBorderRadiusEnum.base,
};

export enum ModalStyleTypeEnum {
    CasinoFavouriteItemModal = 0,
    Betslip = 1,
    CasinoFavorites = 2,
    CasinoTools = 3,
    Confirm = 4,
    DetailsCompact = 5,
    Game = 6,
    Inactivity = 7,
    Login = 8,
    Notification = 9,
    ProfileDetails = 10,
    Reels = 11,
    SignUp = 12,
    VerifyDetails = 13,
    VerifyKYC = 14,
    VerifyWallet = 15,
    Verification = 16,
    Wallet = 17,
    WalletMulti = 18,
    WalletPix = 19,
    WalletTola = 20,
    CustomDropdown = 21,
    WalletMultiPro = 22,
}

export const MODAL_CONFIG_MAP: Record<ModalStyleTypeEnum, Partial<IModalStyleConfig>> = {
    [ModalStyleTypeEnum.CasinoFavouriteItemModal]: CASINO_FAVORITES_ITEM_MODAL_CONFIG,
    [ModalStyleTypeEnum.Betslip]: BETSLIP_MODAL_CONFIG,
    [ModalStyleTypeEnum.CasinoFavorites]: CASINO_FAVORITES_CONFIG,
    [ModalStyleTypeEnum.CasinoTools]: CASINO_TOOLS_CONFIG,
    [ModalStyleTypeEnum.Confirm]: CONFIRM_MODAL_CONFIG,
    [ModalStyleTypeEnum.DetailsCompact]: DETAILS_COMPACT_MODAL_CONFIG,
    [ModalStyleTypeEnum.Game]: GAME_MODAL_CONFIG,
    [ModalStyleTypeEnum.Inactivity]: INACTIVITY_MODAL_CONFIG,
    [ModalStyleTypeEnum.Login]: LOGIN_MODAL_CONFIG,
    [ModalStyleTypeEnum.Notification]: NOTIFICATION_MODAL_CONFIG,
    [ModalStyleTypeEnum.ProfileDetails]: PERSONAL_DETAILS_MODAL_CONFIG,
    [ModalStyleTypeEnum.Reels]: REELS_CONFIG,
    [ModalStyleTypeEnum.SignUp]: SIGNUP_MODAL_CONFIG,
    [ModalStyleTypeEnum.VerifyDetails]: VERIFY_DETAILS_CONFIG,
    [ModalStyleTypeEnum.VerifyKYC]: VERIFY_KYC_MODAL_CONFIG,
    [ModalStyleTypeEnum.VerifyWallet]: VERIFY_WALLET_MODAL_CONFIG,
    [ModalStyleTypeEnum.Verification]: VERIFICATION_MODAL_CONFIG,
    [ModalStyleTypeEnum.Wallet]: WALLET_MODAL_CONFIG,
    [ModalStyleTypeEnum.WalletMulti]: WALLET_MULTI_MODAL_CONFIG,
    [ModalStyleTypeEnum.WalletPix]: WALLET_PIX_MODAL_CONFIG,
    [ModalStyleTypeEnum.WalletTola]: WALLET_TOLA_MODAL_CONFIG,
    [ModalStyleTypeEnum.CustomDropdown]: CUSTOM_DROPDOWN_MODAL_CONFIG,
    [ModalStyleTypeEnum.WalletMultiPro]: WALLET_MULTI_PRO_MODAL_CONFIG,
};
